import React, { useState, useContext, useEffect, useRef, useMemo } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiInput from "components/SuiInput";

import Avatar from "@mui/material/Avatar";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import api from "services/api";

import qs from "query-string";
import toast from "react-hot-toast";

import colors from "assets/theme/base/colors";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import ImportStylePicturesModal from "pages/de/posts/components/ImportStylePicturesModal";
import ImportMoodboardPicture from "pages/de/posts/components/ImportMoodboardPicture";

import ImageIcon from "@mui/icons-material/Image";
import TitleIcon from "@mui/icons-material/Title";
import ViewComfyIcon from "@mui/icons-material/ViewComfy";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CollectionsIcon from "@mui/icons-material/Collections";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";

import StyleIcon from "@mui/icons-material/Style";
import PaletteIcon from "@mui/icons-material/Palette";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import SettingsIcon from "@mui/icons-material/Settings";
import EditIcon from "@mui/icons-material/Edit";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import VerticalSplitIcon from "@mui/icons-material/VerticalSplit";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

import { nanoid } from "nanoid";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import parse from "html-react-parser";
import moment from "moment";
import Cropper from "react-easy-crop";

import UploadIcon from "@mui/icons-material/Upload";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import Slider from "@mui/material/Slider";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ListItemIcon from "@mui/material/ListItemIcon";
import { getImageSize } from "react-image-size";
import PostImageWrapper from "pages/de/posts/components/PostImageWrapper";
import { handleUpdatePostContent } from "utils/helper";
import { Resizable } from "re-resizable";
import ReactPlayer from "react-player";
import Skeleton from "@mui/material/Skeleton";
import { uploadFileSizeLimit } from "utils/imageHelper";

const DEFAULT_MARGIN_X = 60;
const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    //[{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],

    ["clean"], // remove formatting button
  ],
};

const EditColumnGrid = ({
  setPost,
  post,
  handleClickContentStyle,
  columnGrid,
  setSelectedItem,
  parentTextRef,
  pending = false,
}) => {
  const [importStyleVisible, setImportStyleVisible] = useState(false);
  const [importMoodboardVisible, setImportMoodboardVisible] = useState(false);
  const [addTextItem, setAddTextItem] = useState();
  const [selectedColumnIndex, setSelectedColumnIndex] = useState();
  const [gapValue, setGapValue] = useState(columnGrid?.gap || 0);

  const [uploading, setUploading] = useState(false);

  const uploadRef = useRef(null);
  const textRef = useRef(null);
  const parentRef = useRef(null);
  const uploadVideoRef = useRef(null);

  useEffect(() => {
    if (textRef?.current && addTextItem?.id) {
      const editor = textRef.current.getEditor();
      const quillElement = editor.root;
      quillElement.focus();
      editor.getModule("toolbar").container.addEventListener("mousedown", (e) => {
        e.preventDefault();
      });
    }
  }, [textRef?.current, addTextItem]);

  const columnContent = columnGrid?.content || [{}];

  const contentActions = [
    {
      label: "Image",
      icon: <ImageIcon fontSize="medium" />,
      handleClick: () => {
        uploadRef?.current?.click();
      },
    },
    {
      label: "Video/Audio",
      key: "video",
      icon: <PlayCircleIcon fontSize="medium" />,
      handleClick: () => {
        uploadVideoRef?.current?.click();
      },
    },
    {
      label: "Style",
      icon: <StyleIcon fontSize="medium" />,
      handleClick: () => {
        setImportStyleVisible(true);
      },
    },
    {
      label: "Moodboard",
      icon: <PaletteIcon fontSize="medium" />,
      handleClick: () => {
        setImportMoodboardVisible(true);
      },
    },
    {
      label: "Text",
      key: "text",
      icon: <TitleIcon fontSize="medium" />,
      handleClick: (index) => {
        if (parentTextRef?.current) {
          const parentEditor = parentTextRef.current.getEditor();
          parentEditor.blur();
          console.log("blur parent");
        }
        if (!addTextItem?.id) {
          let newTextContent = generateNewTextInput(index);
          setAddTextItem(newTextContent);

          const newContent = [...post?.metadata?.content];
          for (let i = 0; i < newContent.length; i++) {
            if (newContent[i]?.id == columnGrid?.id) {
              const newColumnGrid = { ...columnGrid };
              newColumnGrid["content"][index] = newTextContent;

              newContent[i] = newColumnGrid;
            }
          }

          const newPostData = {
            ...post,
            metadata: {
              ...post.metadata,
              content: newContent,
            },
          };

          setPost(newPostData);
        } else {
          if (textRef?.current && addTextItem) {
            const editor = textRef.current.getEditor();
            const quillElement = editor.root;
            quillElement.focus();
          }
        }
      },
    },
  ];

  const generateNewTextInput = (index) => {
    const newTextContent = {
      ...columnContent[index],
      type: "text",
      mx: DEFAULT_MARGIN_X,
      caption: "",
    };

    newTextContent["width"] = updateColumnWithGap(columnGrid["content"], columnGrid?.gap);
    return newTextContent;
  };

  const handleDeleteById = (item) => {
    const newPost = handleUpdatePostContent(post, item, true, true);
    setPost(newPost);
  };

  const renderColumnGridContent = (item, index) => {
    if (item?.type == "text") {
      return (
        <SuiBox
          sx={{
            mt: 1,
            position: "relative",
          }}
        >
          {addTextItem?.id == item?.id ? (
            <SuiBox mx={1}>
              <ReactQuill
                tabIndex={item?.id}
                placeholder="Enter your text here"
                theme="snow"
                value={addTextItem?.caption || ""}
                onChange={(value) => {
                  setAddTextItem({ ...addTextItem, caption: value });
                }}
                ref={textRef}
                modules={modules}
                onBlur={(previousRange, source, editor) => {
                  console.log("on blur");
                  if (source != "user") {
                    return;
                  }
                  if (textRef?.current) {
                    const textEditor = textRef.current.getEditor();
                    const pureText = textEditor.getText();

                    let newTextItem = { ...addTextItem };

                    if (!pureText.trim()) {
                      //when text is empty,set caption to empty.otherwise the default value could be <p><br/></p>
                      newTextItem.caption = "";
                    }

                    //set caption value to post
                    const newContent = [...post?.metadata?.content];
                    for (let i = 0; i < newContent.length; i++) {
                      if (newContent[i]?.id == columnGrid?.id) {
                        const newColumnGrid = { ...columnGrid };
                        let newColumnContent = newColumnGrid["content"] || {};
                        for (let j = 0; j < newColumnContent.length; j++) {
                          if (newColumnContent[j]?.id == newTextItem.id) {
                            if (newTextItem.caption == "") {
                              delete newTextItem["type"];
                            }
                            newColumnGrid["content"][j] = newTextItem;
                          }
                        }

                        newContent[i] = newColumnGrid;
                      }
                    }

                    const newPostData = {
                      ...post,
                      metadata: {
                        ...post.metadata,
                        content: newContent,
                      },
                    };

                    setPost(newPostData);
                    setAddTextItem(undefined);
                  }
                }}
                onFocus={() => {
                  console.log("I'm focused2");
                }}
              />
            </SuiBox>
          ) : (
            <div
              style={{
                position: "relative",
              }}
              className="hover-parent"
            >
              <SuiBox
                sx={{ width: item?.width || "100%", minHeight: 20 }}
                onClick={() => {
                  setAddTextItem(item);
                }}
              >
                <SuiTypography variant="body1">{parse(item?.caption)}</SuiTypography>
              </SuiBox>
              <SuiBox
                aria-label="close"
                onClick={() => handleDelete(index)}
                sx={{
                  position: "absolute",
                  right: 4,
                  top: 4,
                  backgroundColor: (theme) => theme.palette.grey[500],
                  cursor: "pointer",
                  opacity: 0,
                  borderRadius: "50%",
                  height: 25,
                  width: 25,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className="hover-children"
              >
                <CloseIcon color="white" />
              </SuiBox>
            </div>
          )}
        </SuiBox>
      );
    } else if (item.type == "video") {
      return item?.video ? (
        <ReactPlayer
          controls={true}
          url={item?.video?.url}
          height="100%"
          style={{ minHeight: 50 }}
          width="100%"
          fallback={<Skeleton animation="wave" height={200} width="100%" variant="rectangular" />}
        />
      ) : null;
    } else {
      return item?.img ? (
        <PostImageWrapper
          item={item}
          post={post}
          setPost={setPost}
          isEdit={true}
          handleDelete={handleDeleteById}
        />
      ) : null;
    }
  };

  const handleOnFileChange = async (e) => {
    const prefileList = e?.target?.files;
    const fileList = uploadFileSizeLimit(prefileList);
    if (uploadRef?.current) {
      uploadRef.current.value = "";
    }
    if (fileList.length == 0) {
      return;
    }
    setUploading(true);
    try {
      const { data } = await api.uploads.create(fileList, {}, `/post/${nanoid()}`);
      const results = data?.uploads || [];
      const oldContent = post?.metadata?.content || [];
      if (columnGrid?.id && columnGrid?.type == "column") {
        const findIndex = oldContent.findIndex((x) => x?.id == columnGrid?.id);
        if (findIndex > -1) {
          let columnGrid = oldContent[findIndex] || {};
          if (!oldContent[findIndex]?.content) {
            oldContent[findIndex]["content"] = [];
          }
          let columnContent = columnGrid?.content?.[selectedColumnIndex] || [];
          let mimeType = "image/*";
          for (let j = 0; j < fileList.length; j++) {
            if (fileList[j].name == results[0].name) {
              mimeType = fileList[j].type;
            }
          }
          const dimensions = await getImageSize(results[0].url);
          columnContent = {
            ...columnContent,
            type: "image",
            img: {
              url: results[0].url,
              type: mimeType,
              name: results[0].name,
            },
            mx: DEFAULT_MARGIN_X,
            dimensions: dimensions,
            caption: "",
          };

          columnContent["width"] = updateColumnWithGap(
            oldContent[findIndex]["content"],
            oldContent[findIndex].gap
          );

          oldContent[findIndex]["content"][selectedColumnIndex] = columnContent;
          const newPostData = {
            ...post,
            metadata: {
              ...post?.metadata,
              content: oldContent,
            },
          };

          setPost(newPostData);
        }
      }

      toast.success("Upload successfully!");
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });

      setUploading(false);
    } catch (err) {
      console.log(err);
      toast.error("Upload failed!");

      setUploading(false);
    }
  };

  const handleOnVideoFileChange = async (e) => {
    const prefileList = e?.target?.files;
    const fileList = uploadFileSizeLimit(prefileList);
    if (uploadVideoRef?.current) {
      uploadVideoRef.current.value = "";
    }
    if (fileList.length == 0) {
      return;
    }
    setUploading(true);
    try {
      const { data } = await api.uploads.create(fileList, {}, `/post/${nanoid()}`);
      const results = data?.uploads || [];

      const oldContent = post?.metadata?.content || [];

      if (columnGrid?.id && columnGrid?.type == "column") {
        const findIndex = oldContent.findIndex((x) => x?.id == columnGrid?.id);
        if (findIndex > -1) {
          let columnGrid = oldContent[findIndex] || {};
          if (!oldContent[findIndex]?.content) {
            oldContent[findIndex]["content"] = [];
          }
          let columnContent = columnGrid?.content?.[selectedColumnIndex] || [];
          let mimeType = "image/*";
          for (let j = 0; j < fileList.length; j++) {
            if (fileList[j].name == results[0].name) {
              mimeType = fileList[j].type;
            }
          }
          columnContent = {
            ...columnContent,
            type: "video",
            video: {
              url: results[0].url,
              type: mimeType,
              name: results[0].name,
            },
            mx: DEFAULT_MARGIN_X,
            caption: "",
          };

          columnContent["width"] = updateColumnWithGap(
            oldContent[findIndex]["content"],
            oldContent[findIndex].gap
          );

          oldContent[findIndex]["content"][selectedColumnIndex] = columnContent;
          const newPostData = {
            ...post,
            metadata: {
              ...post?.metadata,
              content: oldContent,
            },
          };

          setPost(newPostData);
        }
      }
      uploadVideoRef.files = [];
      toast.success("Upload successfully!");
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
      setUploading(false);
    } catch (err) {
      console.log(err);
      uploadVideoRef.files = [];

      toast.error("Upload failed!");
      setUploading(false);
    }
  };

  const handleAddStyle = async (selectedStyle, selectedImgs) => {
    let styleContent = [];

    for (let i = 0; i < selectedImgs.length; i++) {
      const dimensions = await getImageSize(selectedImgs[i].url);
      styleContent.push({
        id: nanoid(),
        resource_id: selectedStyle.id,
        resource_title: selectedStyle.title,
        resource_owner_id: selectedStyle?.store?.owner_id,
        type: "style",
        img: selectedImgs[i],
        mx: DEFAULT_MARGIN_X,
        dimensions: dimensions,
        caption: "",
      });
    }
    let oldContent = post?.metadata?.content || [];
    if (columnGrid?.id && columnGrid?.type == "column") {
      const findIndex = oldContent.findIndex((x) => x?.id == columnGrid?.id);
      if (findIndex > -1) {
        let columnGrid = oldContent[findIndex] || {};
        if (!oldContent[findIndex]?.content) {
          oldContent[findIndex]["content"] = [];
        }
        let columnContent = columnGrid?.content?.[selectedColumnIndex] || [];

        const dimensions = await getImageSize(selectedImgs[0].url);
        columnContent = {
          ...columnContent,
          resource_id: selectedStyle.id,
          resource_title: selectedStyle.title,
          resource_owner_id: selectedStyle?.store?.owner_id,
          type: "style",
          img: selectedImgs[0],
          mx: DEFAULT_MARGIN_X,
          dimensions: dimensions,
          caption: "",
        };

        columnContent["width"] = updateColumnWithGap(
          oldContent[findIndex]["content"],
          oldContent[findIndex].gap
        );

        oldContent[findIndex]["content"][selectedColumnIndex] = columnContent;
        const newPostData = {
          ...post,
          metadata: {
            ...post?.metadata,
            content: oldContent,
          },
        };

        setPost(newPostData);
      }
    } else {
      const newContent = [...oldContent, ...styleContent];
      const newPostData = {
        ...post,
        metadata: {
          ...post?.metadata,
          content: newContent,
        },
      };

      setPost(newPostData);
    }

    setImportStyleVisible(false);
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  const handleAddMoodboard = async (selectedMoodboards) => {
    let moodboardContent = [];
    for (let i = 0; i < selectedMoodboards.length; i++) {
      const dimensions = await getImageSize(selectedMoodboards[i].img.url);

      moodboardContent.push({
        id: nanoid(),
        resource_id: selectedMoodboards[i].id,
        resource_title: selectedMoodboards[i]?.name,
        resource_owner_id: selectedMoodboards[i]?.owner?.id,
        type: "moodboard",
        img: selectedMoodboards[i].img,
        mx: DEFAULT_MARGIN_X,
        dimensions: dimensions,
        caption: "",
      });
    }
    const oldContent = post?.metadata?.content || [];
    if (columnGrid?.id && columnGrid?.type == "column") {
      const findIndex = oldContent.findIndex((x) => x?.id == columnGrid?.id);
      if (findIndex > -1) {
        let columnGrid = oldContent[findIndex] || {};
        if (!oldContent[findIndex]?.content) {
          oldContent[findIndex]["content"] = [];
        }
        let columnContent = columnGrid?.content?.[selectedColumnIndex] || [];

        const dimensions = await getImageSize(selectedMoodboards[0].img.url);
        columnContent = {
          ...columnContent,
          resource_id: selectedMoodboards[0].id,
          resource_title: selectedMoodboards[0]?.name,
          resource_owner_id: selectedMoodboards[0]?.owner?.id,
          type: "moodboard",
          img: selectedMoodboards[0].img,
          mx: DEFAULT_MARGIN_X,
          dimensions: dimensions,
          caption: "",
        };

        columnContent["width"] = updateColumnWithGap(
          oldContent[findIndex]["content"],
          oldContent[findIndex].gap
        );

        oldContent[findIndex]["content"][selectedColumnIndex] = columnContent;

        const newPostData = {
          ...post,
          metadata: {
            ...post?.metadata,
            content: oldContent,
          },
        };

        setPost(newPostData);
      }
    } else {
      const newContent = [...oldContent, ...moodboardContent];

      const newPostData = {
        ...post,
        metadata: {
          ...post?.metadata,
          content: newContent,
        },
      };

      setPost(newPostData);
    }

    setImportMoodboardVisible(false);
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  const handleUpdateColumnGrid = (newColumnGrid) => {
    setPost((prevPost) => {
      const oldContent = prevPost?.metadata?.content || [];
      const newContent = [...oldContent];
      const findIndex = oldContent.findIndex((x) => x?.id == columnGrid?.id);
      if (findIndex > -1) {
        newContent[findIndex] = newColumnGrid;
        const newPostData = {
          ...prevPost,
          metadata: {
            ...post?.metadata,
            content: newContent,
          },
        };
        return newPostData;
      }
    });
  };

  const updateColumnWithGap = (newColumnContent, newGap, childWidth) => {
    const gapdelta =
      newColumnContent.length > 1
        ? (newGap * (newColumnContent.length - 1)) / newColumnContent.length
        : 0;

    let parentElemWidth = parentRef?.current?.offsetWidth;

    let childrenWithGap = childWidth ? childWidth : parentElemWidth / newColumnContent.length;
    let childrenNoGap = childrenWithGap - gapdelta;

    return (childrenNoGap * 100) / parentElemWidth + "%";
  };

  const handleRemoveColumn = (index) => {
    const columnContent = columnGrid?.content || [];
    if (columnContent.length > index && columnContent.length > 1) {
      let newColumnContent = [...columnContent];
      const newGap = columnGrid?.gap;

      newColumnContent.splice(index, 1);

      for (let i = 0; i < newColumnContent.length; i++) {
        newColumnContent[i]["width"] = updateColumnWithGap(newColumnContent, newGap);
      }

      const newColumnGrid = {
        ...columnGrid,
        content: newColumnContent,
      };
      handleUpdateColumnGrid(newColumnGrid);
    }
  };

  const handleAddColumn = () => {
    const columnContent = columnGrid?.content || [];
    if (columnContent.length < 6) {
      let newColumnContent = [...columnContent];
      const newGap = columnGrid?.gap;

      newColumnContent.push({
        id: nanoid(),
        width: 0,
      });

      for (let i = 0; i < newColumnContent.length; i++) {
        newColumnContent[i]["width"] = updateColumnWithGap(newColumnContent, newGap);
      }

      const newColumnGrid = {
        ...columnGrid,
        content: newColumnContent,
      };
      handleUpdateColumnGrid(newColumnGrid);
    }
  };
  const handleChangeGap = (value) => {
    setPost((prevPost) => {
      const oldContent = prevPost?.metadata?.content || [];
      const newContent = [...oldContent];
      const findIndex = oldContent.findIndex((x) => x?.id == columnGrid?.id);
      if (findIndex > -1) {
        let parentElemWidth = parentRef?.current?.offsetWidth;
        const columnContent = newContent[findIndex]?.content || [];
        let newColumnContent = [...columnContent];

        const gapdelta =
          newColumnContent.length > 1
            ? Math.floor(
                (columnGrid["gap"] * (newColumnContent.length - 1)) / newColumnContent.length
              )
            : 0;

        for (let i = 0; i < newColumnContent.length; i++) {
          const childWidth =
            (parseFloat(newColumnContent[i]["width"]) / 100) * parentElemWidth + gapdelta;

          console.log(value, childWidth);
          newColumnContent[i]["width"] = updateColumnWithGap(newColumnContent, value, childWidth);
        }

        let newColumnGrid = {
          ...columnGrid,
          content: newColumnContent,
        };
        newColumnGrid["gap"] = value;

        newContent[findIndex] = newColumnGrid;
        const newPostData = {
          ...prevPost,
          metadata: {
            ...post?.metadata,
            content: newContent,
          },
        };
        return newPostData;
      }
    });
  };

  const handleDelete = (columnIndex) => {
    const columnContent = columnGrid?.content || [];
    const newGap = columnGrid?.gap;

    let newColumnContent = [...columnContent];
    newColumnContent[columnIndex] = {
      id: nanoid(),
      width: columnContent[columnIndex]?.width || updateColumnWithGap(columnContent, newGap),
    };
    const newColumnGrid = {
      ...columnGrid,
      content: newColumnContent,
    };
    handleUpdateColumnGrid(newColumnGrid);
  };

  const handleResizeContent = (e, direction, ref, delta, grid, index) => {
    const columnContent = columnGrid?.content || [];

    let newColumnContent = [...columnContent];
    for (let i = 0; i < columnContent.length; i++) {
      if (index == i) {
        const childWidth = ref.offsetWidth || 1;
        let parentElemWidth = parentRef?.current?.offsetWidth || childWidth * columnContent.length;

        newColumnContent[index]["width"] = ((childWidth * 100) / parentElemWidth).toFixed(2) + "%";

        let affectedIndex = index - 1;

        if (direction == "left") {
          if (index > 0) {
            affectedIndex = index - 1;
          } else {
            affectedIndex = index + 1;
          }
        } else if (direction == "right" && index < columnContent.length - 1) {
          if (index < columnContent.length - 1) {
            affectedIndex = index + 1;
          } else {
            affectedIndex = index - 1;
          }
        }

        let oldPercentageWidth =
          newColumnContent[affectedIndex]["width"] || 100 / columnContent.length + "%";
        let affectedChildOriginalWidth = (parseFloat(oldPercentageWidth) / 100) * parentElemWidth;
        let affectedChildNewWidth = affectedChildOriginalWidth - delta.width;

        newColumnContent[affectedIndex]["width"] =
          ((affectedChildNewWidth * 100) / parentElemWidth).toFixed(2) + "%";
      }
    }

    const newColumnGrid = {
      ...columnGrid,
      content: newColumnContent,
    };
    handleUpdateColumnGrid(newColumnGrid);
  };

  return (
    <SuiBox>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => 99999 }} open={uploading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <SuiBox sx={{ width: "100%" }}>
        <SuiBox
          position="relative"
          display="flex"
          alignItems="center"
          gap={2}
          sx={{ mb: 2, pt: 1, flexGrow: 1, px: 2, width: "100%" }}
        >
          <SuiBox
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "none",
                lg: "flex",
                xl: "flex",
              },
              gap: 2,
              alignItems: "center",
              minWidth: 160,
            }}
          >
            <SuiTypography variant="body1" color="dark" sx={{ minWidth: 24, width: 24 }}>
              Cols
            </SuiTypography>
            <RemoveIcon
              sx={{ cursor: "pointer" }}
              fontSize="small"
              onClick={() => handleRemoveColumn(columnContent.length - 1)}
            />
            <SuiBox>{columnGrid?.content?.length || 1}</SuiBox>
            <AddIcon
              sx={{ cursor: "pointer" }}
              fontSize="small"
              onClick={() => handleAddColumn()}
            />
          </SuiBox>
          <SuiBox
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "none",
                lg: "flex",
                xl: "flex",
              },
              gap: 2,
              alignItems: "center",
              width: 180,
              minWidth: 180,
            }}
          >
            <SuiTypography variant="body1" color="dark" sx={{ minWidth: 24, width: 24 }}>
              Gap
            </SuiTypography>
            <Slider
              valueLabelDisplay="auto"
              min={0}
              max={80}
              value={gapValue || 0}
              onChangeCommitted={(e, value) => handleChangeGap(value)}
              onChange={(e, value) => setGapValue(value)}
              sx={{ flexGrow: 1 }}
            />
            <SuiBox>{gapValue || 0}</SuiBox>
          </SuiBox>
        </SuiBox>

        <SuiBox
          sx={{ width: "100%", display: "flex", gap: columnGrid?.gap + "px" }}
          ref={parentRef}
        >
          {columnContent.map((x, index) => {
            return (
              <Resizable
                size={{
                  width: x?.width || (100 * 1.0) / columnContent.length + "%",
                  height: "auto",
                }}
                onResizeStop={(e, direction, ref, d) =>
                  handleResizeContent(e, direction, ref, d, x, index)
                }
                bounds={parentRef?.current}
                style={{ border: "#efefef 1px solid" }}
                enable={{
                  top: false,
                  right: true,
                  bottom: false,
                  left: true,
                  topRight: false,
                  bottomRight: false,
                  bottomLeft: false,
                  topLeft: false,
                }}
              >
                {x?.id && x?.type ? (
                  renderColumnGridContent(x, index)
                ) : (
                  <SuiBox
                    sx={{
                      position: "relative",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      minHeight: 300,
                    }}
                    className="hover-parent"
                  >
                    <SuiBox
                      aria-label="close"
                      onClick={() => handleRemoveColumn(index)}
                      sx={{
                        position: "absolute",
                        right: 4,
                        top: 4,
                        backgroundColor: (theme) => theme.palette.grey[500],
                        cursor: "pointer",
                        opacity: 0,
                        borderRadius: "50%",
                        height: 25,
                        width: 25,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      className="hover-children"
                    >
                      <CloseIcon color="white" />
                    </SuiBox>

                    <SuiTypography variant="h6" color="text" sx={{ my: 1 }}>
                      Add content to your post:
                    </SuiTypography>
                    <SuiBox
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      gap={2}
                      flexWrap={"wrap"}
                    >
                      {contentActions.map((action, actionIndex) => (
                        <SuiBox
                          key={actionIndex}
                          sx={{ textAlign: "center" }}
                          onFocus={() => {
                            console.log("focus me");
                          }}
                          onClick={(e) => {
                            e.target.focus();
                            setSelectedItem(columnGrid);
                            setSelectedColumnIndex(index);
                            action.handleClick(index);
                          }}
                        >
                          <IconButton
                            size="medium"
                            color="dark"
                            sx={{
                              background: "50%",
                              backgroundColor: colors?.lightBlue.main,
                              border: `solid 1px ${colors?.lightBlue.main}`,
                            }}
                          >
                            {action.icon}
                          </IconButton>
                          <SuiTypography variant="body2" color="text" sx={{ my: 1 }}>
                            {action.label}
                          </SuiTypography>
                        </SuiBox>
                      ))}
                    </SuiBox>
                  </SuiBox>
                )}
              </Resizable>
            );
          })}
        </SuiBox>
      </SuiBox>

      <input
        type="file"
        id="imgupload"
        style={{ display: "none" }}
        ref={uploadRef}
        accept="image/*"
        onChange={handleOnFileChange}
        multiple={false}
      />
      {importStyleVisible ? (
        <ImportStylePicturesModal
          handleClose={() => setImportStyleVisible(false)}
          visible={importStyleVisible}
          handleOk={handleAddStyle}
          isMulti={false}
        />
      ) : null}
      {importMoodboardVisible ? (
        <ImportMoodboardPicture
          handleClose={() => setImportMoodboardVisible(false)}
          visible={importMoodboardVisible}
          handleOk={handleAddMoodboard}
          selectedMoodboards={[]}
          isMulti={false}
        />
      ) : null}
      <input
        type="file"
        id="videoupload"
        style={{ display: "none" }}
        ref={uploadVideoRef}
        accept="video/*,audio/*"
        onChange={handleOnVideoFileChange}
      />
    </SuiBox>
  );
};

export default EditColumnGrid;
